var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "info-label" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Etat du compte")))
      ]),
      _vm._v(" "),
      _c(
        "CompassTag",
        {
          attrs: {
            size: "small",
            color: _vm.information.color,
            icon: _vm.information.icon
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.translation) + "\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }